<template>
  <div class="mb-2 o:mb-0" data-test-id="rating-summary">
    <base-button
      v-if="reviewsData?.rollup?.reviewCount"
      class="items-center gap-2 text-base i-flex <lg:mb-2 o:<lg:mb-0"
      @click="openReviewsPanel"
    >
      <span
        aria-hidden="true"
        class="gap-1 c-grey-30 i-flex text-sm lh-5 o:c-brand-1"
      >
        <span class="fw-bold o:order-2">
          {{ reviewsData.rollup.averageRating.toFixed(1) }}
        </span>
        <vf-rating
          class="o:order-1"
          :max="1"
          :value="reviewsData.rollup.averageRating"
        />
        <span class="o:order-3">
          ({{ reviewsData.rollup.reviewCount }})
        </span>
      </span>

      <span class="sr-only">
        <template v-if="reviewsData.rollup.reviewCount">
          {{
            replaceAll(
              $pluralize($t.viewNumberOfReviews, reviewsData.rollup.reviewCount),
              { reviewsCount: reviewsData.rollup.reviewCount },
            )
          }}
        </template>
        <template v-else>
          {{ $t.scrollToReviews }}
        </template>
      </span>
    </base-button>
    <dialog-review-write />
    <panel-product-reviews
      class-content="md:w-128"
      v-bind="{
        data: reviewsData,
        showHeading: false,
      }"
    />
  </div>
</template>

<script lang="ts" setup>
import type { Product } from '#root/api/clients/product/data-contracts'
import type { ProductReviewsData } from '#types/components/product/reviews'

export type Props = {
  product: Product
  reviewsData?: ProductReviewsData
}

const { reviewsData } = defineProps<Props>()

const { reviews: { dialogOptions } } = useAppConfig().pages?.pdp || {}
const { $gtm } = useNuxtApp()

const DialogReviewWrite = createDialog('review-write', dialogOptions.reviewWrite)
const PanelProductReviews = createPanel('product-reviews')

const openReviewsPanel = () => {
  $gtm.push('pdpPage.onViewReviews')
  PanelProductReviews.open()
}
</script>
